import styled from 'styled-components';

import { NewStyleColor } from '../../../../../utils/styles-constants';

interface ButtonProps {
	disabled: boolean;
	iconWidth: string;
	iconHeight: string;
}

const Wrapper = styled('div')`
	box-sizing: border-box;
	display: flex;
	align-items: center;
	justify-content: center;
	flex: 0 0 44px;
`;

const Button = styled('button').attrs({
	type: 'button',
})`
	box-sizing: border-box;
	display: flex;
	align-items: center;
	justify-content: center;
	flex: 0 0 30px;
	height: 30px;
	border: 0;
	outline: 0;
	background-color: transparent;
	color: ${NewStyleColor.Blue450};
	cursor: pointer;

	${({ disabled }: ButtonProps) => disabled && `
		cursor: default;
		opacity: 0.5;
	`}

	svg {
		width: ${({ iconWidth }: ButtonProps) => iconWidth};
		height: ${({ iconHeight }: ButtonProps) => iconHeight};
		fill: currentColor;
	}

	&:not(:last-of-type) {
		margin-right: 20px;
	}
`;

export {
	Wrapper,
	Button,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/Thumbnails/Column/ButtonsPanel/styles.ts